/**
 * Print a PDF blob without window.open — avoids pop-up blockers after async
 * generation (see ipd-billing PdfPreviewModal.js).
 */
export function printPdfBlob(blob) {
  return new Promise((resolve, reject) => {
    if (!blob) {
      reject(new Error("Missing PDF blob"));
      return;
    }

    const url = URL.createObjectURL(blob);
    const iframe = document.createElement("iframe");
    iframe.style.cssText =
      "position:fixed;right:0;bottom:0;width:0;height:0;border:none;";
    iframe.title = "Print";

    let settled = false;
    const finish = (err) => {
      if (settled) return;
      settled = true;
      setTimeout(() => {
        URL.revokeObjectURL(url);
        iframe.remove();
      }, 60000);
      if (err) reject(err);
      else resolve();
    };

    let printed = false;
    const runPrint = () => {
      if (printed) return;
      printed = true;
      try {
        const win = iframe.contentWindow;
        if (!win) throw new Error("Print frame unavailable");
        win.focus();
        win.print();
        finish();
      } catch (err) {
        finish(err);
      }
    };

    iframe.onload = runPrint;
    iframe.onerror = () => finish(new Error("Failed to load PDF for printing"));

    document.body.appendChild(iframe);
    iframe.src = url;

    // Some browsers load PDF plugins without firing onload reliably.
    setTimeout(() => {
      if (!settled) runPrint();
    }, 500);
  });
}
